import React, {useState, useRef, useEffect} from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Loading from '../general/Loading';
import Camera from '../assets/camera-img.png';
import '../css/components/AddProduct.css';

const AddProduct = ({setResponse}) => {
    const navigate = useNavigate();
  const { state } = useLocation();
  const inventoryState = state?.inventoryState;

        const [newCategory, setNewCategory] = useState('');
        const [newSubCategory, setNewSubCategory] = useState('');
        const [newBrand, setNewBrand] = useState('');
        const [loading, setLoading] = useState(true);
        const [uniqueCategory, setUniqueCategory] = useState([]);
        const [uniqueSubCategory, setUniqueSubCategory] = useState([]);
        const [uniqueBrand, setUniqueBrand] = useState([]);
    const [newLoading, setNewLoading] = useState(false);
    const [formData, setFormData] = useState({
        productName: '',
        // productUnit: '',
        stock: '',
        brandName: '',
        category: '',
        subCategory: '',
        mfgDate: '',
        expDate: '',
        images: [],
        purchasePrice: '',
        mrp: '',
        dynamicPricing: [{ qty: '', price: '' }],
        tax: 'none',
        discountType: '',
        discountGiven: '',
        description: '',
        barcode: '',
        custom: '',
    });
    const [imagePreview, setImagePreview] = useState([]);

        useEffect(() => {
            const fetchProducts = async () => {
                try {
                    const response = await fetch(`https://api.hargharmart.com/get-unique-category`);
                    if (response.ok) {
                        const data = await response.json();
                        // console.log(data);
                        setLoading(false);
                        setUniqueBrand(data.brands);
                        // const uniqueCategories = [...new Set(data.map(product => product.category))];
                        setUniqueCategory(data.category);
                        // const uniqueSubCategories = [...new Set(data.map(product => product.subCategory))];
                        setUniqueSubCategory(data.subCategory);
                    } else {
                        console.error('Failed to fetch products');
                        setLoading(false);
                    }
                } catch (error) {
                    console.error('Error fetching products:', error);
                    setLoading(false);
                }
            };
    
            fetchProducts();
        }, []);
    
    
        const fileInputRef = useRef(null);
        const handleImageClick = () => {
            fileInputRef.current.click(); // Trigger file input click
        };
    
const handleChange = (e) => {
  const { id, value, type, files } = e.target;

  if (type === 'file' && id === 'images') {
    const selectedFiles = Array.from(files).slice(0, 3);
    setFormData({
      ...formData,
      images: selectedFiles
    });

    // Preview images
    const previews = selectedFiles.map(file => URL.createObjectURL(file));
    setImagePreview(previews);
  } else {
    setFormData({
      ...formData,
      [id]: value
    });
  }
};
    
        const handleNewCategoryChange = (e) => {
            setNewCategory(e.target.value);
        };
    
        const handleAddNewCategory = () => {
            if (newCategory.trim()) {
                setFormData({ ...formData, category: newCategory });
                setUniqueCategory((prevCategories) => [...prevCategories, newCategory]);
                setNewCategory('');
                        setResponse({ message: `New category added: ${newCategory}`, status: 'success' });
                // setResponse(message`: New category added: ${newCategory}`);
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        };
        

                const handleNewSubCategoryChange = (e) => {
            setNewSubCategory(e.target.value);
        };
    
        const handleAddNewSubCategory = () => {
if (newSubCategory.trim()) {
    setFormData({ ...formData, subCategory: newSubCategory });
    setUniqueSubCategory((prevCategories) => [...prevCategories, newSubCategory]);
    setNewSubCategory('');
    setResponse({ message: `New Sub category added: ${newSubCategory}`, status: 'success' });
    setTimeout(() => {
        setResponse('');
    }, 2000);
}
        };
    

        const handleNewBrandChange = (e) => {
            setNewBrand(e.target.value);
        };
    
        const handleAddNewBrand = () => {
            if (newBrand.trim()) {
                setFormData({ ...formData, brandName: newBrand });
                setUniqueBrand((prevBrands) => [...prevBrands, newBrand]);
                setNewBrand('');
                        setResponse({ message: `New brand added: ${newBrand}`, status: 'success' });
                // setResponse(message`: New category added: ${newCategory}`);
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        };
        



        const handleDynamicPricingChange = (index, field, value) => {
  const updatedPricing = [...formData.dynamicPricing];
  updatedPricing[index][field] = value;
  setFormData({ ...formData, dynamicPricing: updatedPricing });
};

const handleAddDynamicPricing = () => {
  setFormData({
    ...formData,
    dynamicPricing: [...formData.dynamicPricing, { qty: '', price: '' }],
  });
};

const handleRemoveDynamicPricing = (index) => {
  const updatedPricing = formData.dynamicPricing.filter((_, i) => i !== index);
  setFormData({ ...formData, dynamicPricing: updatedPricing });
};

        const handleCancel = () => {
            setFormData({
                ...formData,
                category: '',
            });
            setNewCategory('');
            setNewSubCategory('');
        };

                const handleSubCancel = () => {
            setFormData({
                ...formData,
                subCategory: '',
            });
            // setNewCategory('');
            setNewSubCategory('');
        };

    
const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSubmit = new FormData();
Object.keys(formData).forEach((key) => {
  if (key === 'images') {
    formData.images.forEach((img) => formDataToSubmit.append('images', img));
  } else if (key === 'dynamicPricing') {
    formDataToSubmit.append('dynamicPricing', JSON.stringify(formData.dynamicPricing));
  } else {
    formDataToSubmit.append(key, formData[key]);
  }
});


    setNewLoading(true);

  try {
    const response = await fetch('https://api.hargharmart.com/add-product', {
      method: 'POST',
      body: formDataToSubmit
    });

    const data = await response.json(); 
    setNewLoading(false);

    if (response.ok) {
      setResponse({ message: data.message || 'Product Added successfully.', status: 'success' });
      setTimeout(() => setResponse(''), 2000);

      // reset state
      setFormData({
        productName: '',
        stock: '',
        brandName: '',
        category: '',
        subCategory: '',
        mfgDate: '',
        expDate: '',
        images: [],
        purchasePrice: '',
        mrp: '',
        dynamicPricing: [{ qty: '', price: '' }],
        tax: 'none',
        discountType: '',
        discountGiven: '',
        description: '',
        custom: '',
      });
      setImagePreview([]);
    } else {
      setResponse({ message: data.message || 'Failed to add product.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    }
  } catch (error) {
    console.error('Error:', error);
    setNewLoading(false);
  }
};
    

const [checking, setChecking] = useState(false);

const checkProductName = async () => {
  if (!formData.productName.trim()) {
    setResponse({
      message: 'Enter product name to Check duplicate.',
      status: 'error',
    });
          setTimeout(() => setResponse(''), 2000);

    return;
  }

  try {
    setChecking(true);

    const response = await fetch(
      `https://api.hargharmart.com/check-product-name?productName=${encodeURIComponent(formData.productName)}`
    );

    const data = await response.json();

    if (response.status == 200) {
      setResponse({
        message: 'Product exists with this Name',
        status: 'error',
      });
    } else {
      setResponse({
        message: 'Product name available',
        status: 'success',
      });
    }

    setTimeout(() => setResponse(''), 2000);
  } catch (error) {
    // console.error(error);
    setResponse({
      message: 'Error checking product name',
      status: 'error',
    });
  } finally {
    setChecking(false);
  }
};

const handleBack = () => {
  if (inventoryState?.from == 'Inventory') {
    navigate('/inventory', {
      state: { inventoryState }
    });
  } else {
    navigate(-1);
  }
};


  return (
    <>
      <section className='my-4'>
<div className='px-4'>

<div className='d-flex justify-content-between'>
        <p className='page-title'>Add New Product</p>

        {inventoryState?.from == 'Inventory' &&
<button className='close-btn' onClick={handleBack}>Back to Inventory</button>}
</div>

                    <form className="row g-3 bg-white rounded-2 mt-3" onSubmit={handleSubmit}>
                        {/* Product Name */}

                        <div className='col-lg-4'>
                                                <p className='fw-semibold'>Product Details</p>

                        <div className="col-12 mt-2">
                            <label htmlFor="productName" className="profile-label">Product Name</label>
                            <div className='d-flex'>
                            <input
                                type="text"
                                className="product-control"
                                id="productName"
                                value={formData.productName}
                                onChange={handleChange}
                                required
                            />
<button
  type="button"
  className="edit-btn px-3 py-1 ms-1 my-1"
  onClick={checkProductName}
  disabled={checking}
>
  {checking ? 'Checking...' : 'Check'}
</button></div>                        </div>

                        <div className="col-12 mt-2">
                            <label htmlFor="brandName" className="profile-label">Brand Name</label>
                            {/* <input
                                type="text"
                                className="product-control"
                                id="brandName"
                                value={formData.brandName}
                                onChange={handleChange}
                                required
                            /> */}
                                                        <select
                                id="brandName"
                                className="product-control"
                                value={formData.brandName}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select Brand</option>
                                <option value="addNewBrand" className='bg-dark cursor-pointer text-light fw-semibold'>Add New Brand</option>
                                {loading ? (
                                    <option>Loading...</option>
                                ) : (
                                    // Map over the unique categories
                                    uniqueBrand.map((brand, index) => (
                                        <option key={index} value={brand}>
                                            {brand}
                                        </option>
                                    ))
                                )}
                            </select>

                            {formData.brandName === 'addNewBrand' && (
                                <div className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner col-lg-4 mx-auto px-lg-5 py-lg-5 px-3 py-3'>
                                        <div className='my-4'>
                                            <label htmlFor="newBrand" className="profile-label">New Brand</label>
                                            <input
                                                type="text"
                                                id='newBrand'
                                                className="product-control"
                                                placeholder="Enter New Category"
                                                value={newBrand}
                                                onChange={handleNewBrandChange}
                                            />
                                        </div>
                                        <button className='close-btn' onClick={handleCancel}>Cancel</button>&nbsp;&nbsp;
                                        <button type="button" className="edit-btn" onClick={handleAddNewBrand}>Add</button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="col-12 mt-2">
                            <label htmlFor="category" className="profile-label">Category</label>
                            <select
                                id="category"
                                className="product-control"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select Category</option>
                                <option value="addNewCategory" className='bg-dark cursor-pointer text-light fw-semibold'>Add New Category</option>
                                {loading ? (
                                    <option>Loading...</option>
                                ) : (
                                    // Map over the unique categories
                                    uniqueCategory.map((category, index) => (
                                        <option key={index} value={category}>
                                            {category}
                                        </option>
                                    ))
                                )}
                            </select>

                            {formData.category === 'addNewCategory' && (
                                <div className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner col-lg-4 mx-auto px-lg-5 py-lg-5 px-3 py-3'>
                                        <div className='my-4'>
                                            <label htmlFor="newCategory" className="profile-label">New Category</label>
                                            <input
                                                type="text"
                                                id='newCategory'
                                                className="product-control"
                                                placeholder="Enter New Category"
                                                value={newCategory}
                                                onChange={handleNewCategoryChange}
                                            />
                                        </div>
                                        <button className='close-btn' onClick={handleCancel}>Cancel</button>&nbsp;&nbsp;
                                        <button type="button" className="edit-btn" onClick={handleAddNewCategory}>Add</button>
                                    </div>
                                </div>
                            )}
                        </div>


                        <div className="col-12 mt-2">
<label htmlFor="subCategory" className="profile-label">Sub Category</label>
<select
    id="subCategory"  // ✅ Correct
    className="product-control"
    value={formData.subCategory}
    onChange={handleChange}
>
                                <option value="" disabled>Select Sub Category</option>
                                <option value="addNewSubCategory" className='bg-dark cursor-pointer text-light fw-semibold'>Add New Sub Category</option>
                                {loading ? (
                                    <option>Loading...</option>
                                ) : (
                                    // Map over the unique categories
                                    uniqueSubCategory.map((category, index) => (
                                        <option key={index} value={category}>
                                            {category}
                                        </option>
                                    ))
                                )}
                            </select>

                            {formData.subCategory === 'addNewSubCategory' && (
                                <div className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner col-lg-4 mx-auto px-lg-5 py-lg-5 px-3 py-3'>
                                        <div className='my-4'>
                                            <label htmlFor="newSubCategory" className="profile-label">New Sub Category</label>
                                            <input
                                                type="text"
                                                id='newSubCategory'
                                                className="product-control"
                                                placeholder="Enter New Sub Category"
                                                value={newSubCategory}
                                                onChange={handleNewSubCategoryChange}
                                            />
                                        </div>
                                        <button className='close-btn' onClick={handleSubCancel}>Cancel</button>&nbsp;&nbsp;
                                        <button type="button" className="edit-btn" onClick={handleAddNewSubCategory}>Add</button>
                                    </div>
                                </div>
                            )}
                        </div>


                        <div className="col-12 mt-2">
                            <label htmlFor="mfgDate" className="profile-label">Mfg Date</label>
                            <input
                                type="date"
                                className="product-control"
                                id="mfgDate"
                                value={formData.mfgDate}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-12 mt-2">
                            <label htmlFor="expDate" className="profile-label">Exp Date</label>
                            <input
                                type="date"
                                className="product-control"
                                id="expDate"
                                value={formData.expDate}
                                onChange={handleChange}
                            />
                        </div>

                                                                        <div className="col-12 mt-2">
                            <label htmlFor="barcode" className="profile-label">Barcode</label>
                            <input
                                type="text"
                                className="product-control"
                                id="barcode"
                                value={formData.barcode}
                                onChange={handleChange}
                            />
                        </div>
</div>
{/* col 1 ends */}


<div className='col-lg-4'>

                                                <p className='fw-semibold'>Price Details</p>

                        {/* Purchase Price */}
                        <div className="col-12 mt-2">
                            <label htmlFor="purchasePrice" className="profile-label">Purchase Price</label>
                            <input
                                type="number"
                                className="product-control"
                                id="purchasePrice"
                                value={formData.purchasePrice}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Original Price */}
                        <div className="col-12 mt-2">
                            <label htmlFor="mrp" className="profile-label">MRP</label>
                            <input
                                type="number"
                                className="product-control"
                                id="mrp"
                                value={formData.mrp}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Sell Price */}
                        {/* <div className="col-12 mt-2">
                            <label htmlFor="sellPrice" className="profile-label">Sell Price</label>
                            <input
                                type="number"
                                className="product-control"
                                id="sellPrice"
                                value={formData.sellPrice}
                                onChange={handleChange}
                                required
                            />
                        </div> */}
                        <div className="col-12 mt-2">
  <label className="profile-label">Set Dynamic Sale Price</label>
  {formData.dynamicPricing.map((item, index) => (
    <div key={index} className="d-flex align-items-center mt-2">
      <input
        type="number"
        placeholder="Qty"
        className="product-control me-2"
        value={item.qty}
        onChange={(e) => handleDynamicPricingChange(index, 'qty', e.target.value)}
        style={{ width: '30%' }}
        required
      />
      <input
        type="number"
        placeholder="Price"
        className="product-control me-2"
        value={item.price}
        onChange={(e) => handleDynamicPricingChange(index, 'price', e.target.value)}
        style={{ width: '50%' }}
        required
      />
      <button
        type="button"
        className="close-btn px-2 py-0"
        onClick={() => handleRemoveDynamicPricing(index)}
      >
        ×
      </button>
    </div>
  ))}
  <br />
  <button
    type="button"
    className="edit-btn px-3 py-1"
    onClick={handleAddDynamicPricing}
  >
    + Add More
  </button>
</div>
                        {/* Tax Applicable */}
                        <div className="col-12 mt-2">
                            <label className="profile-label" htmlFor="tax">Tax Applicable</label>
                            <select
                                className="product-control"
                                id="tax"
                                value={formData.tax}
                                onChange={handleChange}
                                selected
                            >
                                <option value="none">None</option>
                                <option value="GST 0">GST 0%</option>
                                {/* <option value="IGST 0">IGST 0%</option> */}
                                <option value="GST 0.25">GST 0.25%</option>
                                {/* <option value="IGST 0.25">IGST 0.25%</option> */}
                                <option value="GST 3">GST 3%</option>
                                {/* <option value="IGST 3">IGST 3%</option> */}
                                <option value="GST 5">GST 5%</option>
                                {/* <option value="IGST 5">IGST 5%</option> */}
                                <option value="GST 12">GST 12%</option>
                                {/* <option value="IGST 12">IGST 12%</option> */}
                                <option value="GST 18">GST 18%</option>
                                {/* <option value="IGST 18">IGST 18%</option> */}
                                <option value="GST 28">GST 28%</option>
                                {/* <option value="IGST 28">IGST 28%</option> */}
                            </select>
                        </div>

                        {/* Discount Type */}
                        <div className="col-12 mt-2">
                            <label className="profile-label" htmlFor="discountType">Sell Price Discount</label>
                            <select
                                className="product-control"
                                id="discountType"
                                value={formData.discountType}
                                onChange={handleChange}
                                selected
                            >
                                <option value="">Choose...</option>
                                <option value="percent">Percent %</option>
                                <option value="amount">Amount ₹</option>
                            </select>
                        </div>

                        {/* Discount Given */}
                        <div className="col-12 mt-2">
                            <label className="profile-label" htmlFor="discountGiven">Discount Given</label>
                            <input
                                type="number"
                                className="product-control"
                                id="discountGiven"
                                value={formData.discountGiven}
                                onChange={handleChange}
                            />
                        </div>


</div>
{/* col 2 ends */}

<div className='col-lg-4'>
                             
                                                    <div className="col-12 mt-2 text-center">
<input
  type="file"
  className="profile-control"
  id="images"
  ref={fileInputRef}
  onChange={handleChange}
  multiple
  accept="image/*"
  style={{ display: 'none' }}
/>
<div className="col-12 mt-2 text-center">
  {imagePreview.length > 0
    ? imagePreview.map((preview, index) => (
        <img
          key={index}
          src={preview}
          className="camera-img px-1"
          alt={`Preview ${index + 1}`}
          style={{ height: '100px' }}
        />
      ))
    : <img src={Camera} className="camera-img" alt="Upload" />
  }

<br />
  <button type="button" className="edit-btn px-3 py-1 mt-2" onClick={handleImageClick}>
    Upload Image
  </button>
</div>

                        </div>

                                                <div className="col-12 mt-2">
                            <label htmlFor="description" className="profile-label">Description</label>
                            <textarea
                                className="product-control"
                                style={{ height: '9em' }}
                                id="description"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </div>

                                                                        <div className="col-12 mt-2">
                            <label htmlFor="stock" className="profile-label">Stock</label>
                            <input
                                type="number"
                                className="product-control"
                                id="stock"
                                value={formData.stock}
                                onChange={handleChange}
                            />
                        </div>

                                                                        <div className="col-12 mt-2">
                            <label htmlFor="custom" className="profile-label">Custom ('|' Seperated)</label>
                            <input
                                type="text"
                                className="product-control"
                                id="custom"
                                value={formData.custom}
                                onChange={handleChange}
                            />
                        </div>

</div>


                        {/* Submit Button */}
                        <div className="col-12 text-end">
                            <button type="submit" className="edit-btn">Submit Details</button>
                        </div>
                    </form>


</div>
      </section>

                  {newLoading && <Loading setLoading={setNewLoading} />}
            {/* {response && <ResponseMsg message={response} />} */}

    </>
  )
}

export default AddProduct
